var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperTeeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-srv-c320": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 229.002 195.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-srv-c320": "",
    id: "upper_arch",
    "data-name": "upper arch",
    transform: "translate(1.001 1)",
    className: "tooth"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 23,
    "data-name": "Path 399",
    d: "M216.7,841.571c1.868,2.274,6.961,1.821,10.707,1.264s12.107-4.07,14.155-5.486c.554-.378,3.041-2.485,2.919-4.434-.283-4.465-1.577-11.745-2.1-12.395s-7.418-3.341-11.749-4.5c-1.883-.5-4.437,1.521-4.913,2-1.8,1.728-6.873,9.237-8.158,12.806s-2.854,8.316-.857,10.748",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL3"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 24,
    "data-name": "Path 400",
    d: "M227.249,859.34a10.251,10.251,0,0,1,1.119-11.041c1.84-2.046,14.654-10.495,17.448-10.717,3.2-.264,8.165,2.392,10.367,6.6s1.561,9.807-.472,12.283c-1.775,2.17-16.016,7.894-18.744,8.248a10.254,10.254,0,0,1-9.718-5.371",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL4"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 25,
    "data-name": "Path 401",
    d: "M235.872,878.633a10.251,10.251,0,0,1,2.361-10.848c2.061-1.82,15.753-8.761,18.554-8.665,3.2.1,7.842,3.3,9.551,7.732s.437,9.922-1.868,12.148c-2,1.956-16.8,6.03-19.555,6.068a10.248,10.248,0,0,1-9.043-6.435",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL5"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 21,
    "data-name": "Path 402",
    d: "M185.448,826.41c-3.388-.7-7.109-8.782-7.842-14.691a104.286,104.286,0,0,1-.9-11.746c-.038-2.592,1.328-6.3,4.432-6.285a62.769,62.769,0,0,1,10.738,1.411,64.613,64.613,0,0,1,10.42,2.92c2.87,1.212,2.66,5.162,1.608,7.533a103.861,103.861,0,0,1-5.457,10.439c-3.006,5.15-9.608,11.111-12.995,10.419",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL1"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 22,
    "data-name": "Path 403",
    d: "M202.517,831.065c-2.252-1.436-2.22-9.076-.719-14.159a104.8,104.8,0,0,1,3.366-9.963c.87-2.153,3.15-4.888,5.435-4.084a41.773,41.773,0,0,1,7.416,3.9,42.3,42.3,0,0,1,6.676,5.073c1.7,1.729.179,4.95-1.409,6.647-2.656,2.843-5.381,5.293-7.611,7.258-3.982,3.494-10.893,6.767-13.154,5.325",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL2"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 26,
    "data-name": "Path 404",
    d: "M244.16,904.427c-1.918-2.364-4.168-8.506-1.526-12.445,3.861-5.773,9.16-6.8,13.383-8.157s11.639-2.405,15.123.17c3.991,2.949,4.8,8.257,3.411,12.671,3.336,3.207,5.168,8.253,3.085,12.754-1.824,3.93-8.833,6.563-13.192,7.4s-9.5,2.475-15.654-.736c-4.2-2.194-5.18-8.66-4.63-11.658",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL6"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 27,
    "data-name": "Path 405",
    d: "M250.8,938.372c-1.751-2.494-3.56-8.779-.654-12.526,4.256-5.485,9.615-6.142,13.925-7.2s11.777-1.585,15.073,1.224c3.775,3.224,4.212,8.574,2.515,12.882,3.1,3.43,4.579,8.594,2.185,12.938-2.094,3.791-9.268,5.93-13.675,6.461s-9.648,1.8-15.565-1.83c-4.042-2.482-4.56-9-3.8-11.95",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL7"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 28,
    "data-name": "Path 406",
    d: "M255.772,971.181c-1.38-2.716-2.289-9.19,1.114-12.49,4.989-4.832,10.386-4.729,14.8-5.167s11.882.087,14.747,3.334c3.284,3.722,2.963,9.08.68,13.107,2.592,3.834,3.323,9.155.339,13.116-2.6,3.46-10.008,4.567-14.442,4.471s-9.81.429-15.158-4c-3.649-3.025-3.246-9.553-2.081-12.368",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UL8"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 13,
    "data-name": "Path 407",
    d: "M135.084,841.571c-1.867,2.274-6.96,1.821-10.706,1.264s-12.107-4.07-14.156-5.486c-.554-.378-3.041-2.485-2.918-4.434.283-4.465,1.576-11.745,2.1-12.395s7.418-3.341,11.748-4.5c1.884-.5,4.438,1.521,4.914,2,1.795,1.728,6.872,9.237,8.157,12.806s2.855,8.316.857,10.748",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR3"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 14,
    "data-name": "Path 408",
    d: "M124.539,859.34a10.251,10.251,0,0,0-1.12-11.041c-1.84-2.046-14.654-10.495-17.448-10.717-3.2-.264-8.164,2.392-10.367,6.6s-1.561,9.807.473,12.283c1.774,2.17,16.015,7.894,18.743,8.248a10.256,10.256,0,0,0,9.719-5.371",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR4"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 15,
    "data-name": "Path 409",
    d: "M115.915,878.633a10.249,10.249,0,0,0-2.361-10.848c-2.061-1.82-15.753-8.761-18.554-8.665-3.2.1-7.842,3.3-9.551,7.732s-.436,9.922,1.868,12.148c2,1.956,16.8,6.03,19.556,6.068a10.245,10.245,0,0,0,9.042-6.435",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR5"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 11,
    "data-name": "Path 410",
    d: "M166.34,826.41c3.387-.7,7.109-8.782,7.842-14.691a104.075,104.075,0,0,0,.9-11.746c.038-2.592-1.328-6.3-4.432-6.285a62.769,62.769,0,0,0-10.738,1.411,64.613,64.613,0,0,0-10.42,2.92c-2.87,1.212-2.659,5.162-1.607,7.533a103.669,103.669,0,0,0,5.456,10.439c3.007,5.15,9.608,11.111,13,10.419",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR1"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 12,
    "data-name": "Path 411",
    d: "M149.27,831.065c2.253-1.436,2.22-9.076.72-14.159a104.838,104.838,0,0,0-3.367-9.963c-.869-2.153-3.149-4.888-5.434-4.084a41.773,41.773,0,0,0-7.416,3.9,42.212,42.212,0,0,0-6.676,5.073c-1.7,1.729-.18,4.95,1.409,6.647,2.656,2.843,5.381,5.293,7.61,7.258,3.983,3.494,10.893,6.767,13.154,5.325",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR2"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 16,
    "data-name": "Path 412",
    d: "M107.627,904.427c1.918-2.364,4.168-8.506,1.526-12.445-3.861-5.773-9.159-6.8-13.383-8.157s-11.638-2.405-15.122.17c-3.991,2.949-4.8,8.257-3.411,12.671-3.337,3.207-5.169,8.253-3.086,12.754,1.825,3.93,8.834,6.563,13.192,7.4s9.5,2.475,15.655-.736c4.2-2.194,5.179-8.66,4.629-11.658",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR6"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 17,
    "data-name": "Path 413",
    d: "M100.984,938.372c1.75-2.494,3.56-8.779.654-12.526-4.257-5.485-9.615-6.142-13.925-7.2s-11.778-1.585-15.074,1.224c-3.775,3.224-4.211,8.574-2.514,12.882-3.1,3.43-4.579,8.594-2.185,12.938,2.093,3.791,9.268,5.93,13.674,6.461s9.648,1.8,15.565-1.83c4.043-2.482,4.56-9,3.805-11.95",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR7"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 18,
    "data-name": "Path 414",
    d: "M96.016,971.181c1.38-2.716,2.288-9.19-1.114-12.49-4.99-4.832-10.386-4.729-14.8-5.167s-11.883.087-14.748,3.334c-3.283,3.722-2.963,9.08-.679,13.107-2.592,3.834-3.324,9.155-.34,13.116,2.6,3.46,10.008,4.567,14.442,4.471s9.81.429,15.158-4c3.65-3.025,3.246-9.553,2.082-12.368",
    transform: "translate(-62.394 -793.688)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "UR8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperTeeth);
export default __webpack_public_path__ + "static/media/upper-teeth.6d4909e15a25d67d52779e609bf724e3.svg";
export { ForwardRef as ReactComponent };